import axios from "axios";

export const getService = async () => {
  return await axios
    .get(`${process.env.REACT_APP_BASE_URL}/quotations`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(`Error retrieving Contact data: ${error.message}`);
    });
};

export const softDeleteService = async (table, id, username) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/quotations/soft-delete/${id}`,
      { username }
    );

    await logService(username, "Soft Delete", table);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const softDeleteAllService = async (table, username) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/quotations/soft-delete-all`,
      { username: username }
    );

    await logService(username, "Soft Delete All", table);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteRowService = async (table, id, username) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/quotations/delete/${id}`,
      {
        params: { id },
      }
    );

    await logService(username, "Perm Delete", table);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteAllService = async (table, username) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/quotations/delete-all`
    );

    await logService(username, "Perm Delete All", table);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const restoreRowService = async (table, id, username) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/quotations/restore/${id}`
    );

    await logService(username, "Restore", table);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const restoreAllService = async (table, username) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/quotations/restore-all`
    );

    await logService(username, "Restore All", table);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const logService = async (username, actionType, tableName) => {
  try {
    await axios.post(`${process.env.REACT_APP_BASE_URL}/logs`, {
      username,
      actionType,
      tableName,
      timestamp: new Date(),
    });
  } catch (error) {
    throw error;
  }
};
